import React from "react";
import {
  DataGrid,
  DataGridProps,
  GridColDef,
  GridSlotsComponent,
  GridSlotsComponentsProps,
} from "@material-ui/data-grid";

import classes from "./BaseDataGrid.module.scss";

export type DataGridRowType<T extends { field: string }[]> = Record<T[number]["field"], any>;

type BaseDataGridProps<T extends GridColDef[]> = {
  columns: T;
  rows: DataGridRowType<T>[];
  components?: GridSlotsComponent;
  componentsProps?: GridSlotsComponentsProps;
  autoHeight?: boolean;
};

const mergeComponentsProps = (componentsProps?: GridSlotsComponentsProps): GridSlotsComponentsProps => ({
  ...componentsProps,
  panel: {
    ...componentsProps?.panel,
    popperOptions: {
      positionFixed: true,
      ...componentsProps?.panel?.popperOptions,
    },
  },
});

const BaseDataGrid = <T extends GridColDef[]>({
  columns,
  rows,
  components,
  componentsProps,
  autoHeight,
  ...rest
}: BaseDataGridProps<T> & DataGridProps) => {
  const mergedComponentsProps = mergeComponentsProps(componentsProps);

  return (
    <div className={classes.container}>
      <DataGrid
        autoHeight={!!autoHeight}
        components={components}
        componentsProps={mergedComponentsProps}
        columns={columns}
        rows={rows}
        isRowSelectable={() => false}
        {...rest}
      />
    </div>
  );
};

export default BaseDataGrid;
